<template>
  <div class="Cost flex-column">
    <div class="page-title flex-fixed">
      {{ $t("lang.title_cost") }}
    </div>
    <div class="flex flex-auto">
      <div class="tree-container">
        <AProductTypeTreeSelector @select="handleSelectProductType" />
      </div>
      <div style="width:calc(100% - 170px);">
        <ATable
          ref="table"
          :loading="loading"
          highlight-current-row
          hide-button-insert
          :placeholder="placeholder"
          :search_field="search_field"
          :data="items"
          :exportExcel="handleClickExportExcel"
          border
          @cell-click="handleCellClick"
        >
          <div slot="search" class="text-warning">
            요율로 등록하려면 가격 좌측의 체크 박스를 선택하세요.
          </div>
          <el-table-column
            type="index"
            label="No"
            :index="handleIndex"
            :width="$width.indexw"
          />
          <el-table-column prop="code" width="80" :label="$t('lang.code')" />
          <el-table-column
            prop="name"
            :label="$t('lang.material_name')"
            min-width="180"
            show-overflow-tooltip
          />
          <el-table-column
            prop="price"
            :label="$t('lang.base_price')"
            width="90"
            class-name="cell-number"
          >
            <template slot-scope="scope">
              <div v-if="scope.row.id === editingId">
                <ANumberInput
                  :disabled="!has_grant_write"
                  v-model="scope.row.price.price"
                />
              </div>
              <div v-else>
                {{ util.addComma(scope.row.price.price) }}
              </div>
            </template>
          </el-table-column>
          <el-table-column
            v-for="level in table_customer_level"
            width="80"
            class-name="cell-number"
            :key="level.id"
            :label="level.code"
            prop="price"
          >
            <template slot-scope="scope">
              <div class="flex">
                <div class="price-ratio">
                  <span v-if="scope.row.id === editingId">
                    <ACheckboxYN
                      v-model="scope.row.price.custom[level.id].ratio_flag"
                      :disabled="!has_grant_write"
                    />
                  </span>
                  <span v-else>
                    <i
                      class="el-icon-check"
                      v-show="
                        scope.row.price.custom[level.id].ratio_flag === 'Y'
                      "
                    />
                  </span>
                </div>
                <div class="flex-auto">
                  <div v-if="scope.row.id === editingId">
                    <ANumberInput
                      :disabled="!has_grant_write"
                      v-model="scope.row.price.custom[level.id].price"
                    />
                  </div>
                  <div v-else>
                    {{ util.addComma(scope.row.price.custom[level.id].price) }}
                  </div>
                </div>
              </div>
            </template>
          </el-table-column>

          <el-table-column label="" width="60">
            <template slot-scope="scope">
              <span class="flex">
                <el-button
                  v-if="scope.row.id === editingId"
                  size="mini"
                  icon="el-icon-check"
                  type="primary"
                  circle
                  :disabled="!has_grant_write"
                  @click="handleClickSave(scope.row)"
                />
                <el-button
                  v-if="scope.row.id === editingId"
                  size="mini"
                  icon="el-icon-close"
                  type="danger"
                  circle
                  :disabled="!has_grant_write"
                  @click="handleClickClose()"
                />
              </span>
            </template>
          </el-table-column>
          <el-table-column label="이력" width="60">
            <template slot-scope="scope">
              <el-popover
                placement="left"
                width="850"
                :disabled="editingId !== 0"
              >
                <CostHistory :data="scope.row" :visible="visibleId" />
                <el-button
                  size="tiny"
                  slot="reference"
                  @click="handleClickHistory(scope.row)"
                  >이력</el-button
                >
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            prop="created_user_name"
            :label="$t('lang.created_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="modified_user_name"
            :label="$t('lang.modified_user_name')"
            :width="$width.username"
          />
          <el-table-column
            prop="created_at"
            :label="$t('lang.created_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
          <el-table-column
            prop="modified_at"
            :label="$t('lang.modified_at')"
            :width="$width.date"
            :formatter="util.dateFormat"
          />
          <!--<div slot="buttons">
            <el-upload
              class="inline"
              action="#"
              :show-file-list="false"
              :auto-upload="false"
              :on-change="handleOnChange"
            >
              <el-button
                type="primary"
              >단가 엑셀 등록</el-button>
            </el-upload>
          </div>-->
        </ATable>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { enter_tab } from "@/common/mixins/enter_tab";
import { authority_level } from "@/common/mixins/authority_level";
import CostHistory from "./CostHistory";
import XLSX from "xlsx";

export default {
  name: "Cost",
  components: { CostHistory },
  mixins: [enter_tab, authority_level],
  data() {
    return {
      placeholder: "코드, 품목명",
      search_field: ["code", "name"],
      search_type_id: 0,
      originPrice: null,
      editingId: 0,
      visibleId: 0,
      loading: false,
      excelProductInfo: [
        this.$t("lang.code"),
        this.$t("lang.material_name"),
        this.$t("lang.base_price"),
      ],
    };
  },
  computed: {
    ...mapGetters([
      "table_customer_level",
      "table_product",
      "table_product_price",
    ]),
    items: function() {
      let items = Object.assign(
        [],
        this.table_product.filter((p) => {
          if (this.search_type_id < 1) {
            return true;
          }
          return p.type_id === this.search_type_id;
        })
      );
      items.forEach((item) => {
        // 가격 정보를 찾아 제품 데이터에 넣는다.
        let price = this.table_product_price.find(
          (pp) => pp.product_id === item.id
        );
        if (!price) {
          price = {
            id: 0,
            product_id: item.id,
            price: 0,
            use_flag: "Y",
            customers: [],
          };
        }
        if (!price.price) price.price = 0;
        let customs = {};
        this.table_customer_level.forEach((cl) => {
          let pc = price.customers.find((c) => c.customer_level_id === cl.id);
          let cp = { customer_level_id: cl.id };
          if (pc) {
            cp = {
              id: pc.id,
              customer_level_id: cl.id,
              ratio_flag: pc.ratio_flag,
              price: pc.price,
            };
          } else {
            cp = {
              id: 0,
              customer_level_id: cl.id,
              ratio_flag: "N",
              price: "",
            };
          }
          customs[cl.id] = cp;
        });
        price.custom = customs;
        item.price = price;
      });
      return items;
    },
    has_grant_write() {
      return this.isWriteLevel("cost");
    },
  },
  methods: {
    doRegister(item) {
      if (!this.editingId) {
        return;
      }
      let pp = Object.assign({}, item.price);
      if (!pp.price) {
        pp.price = null;
      }
      pp.customers = [];
      for (let key in pp.custom) {
        if (pp.custom[key].price) {
          // pp.custom[key].ratio_flag = pp.custom[key].ratio_flag ? 'Y' : 'N';
          pp.customers.push(pp.custom[key]);
        }
      }
      if (!pp.price && pp.customers.length < 1) {
        if (!pp.id) {
          return;
        }
        // delete
        this.api.deleteProductPrice(pp).then((res) => {
          this.handleResult(res);
        });
      } else {
        // insert & update
        this.api.saveProductPrice(pp).then((res) => {
          this.handleResult(res);
        });
      }
    },
    handleIndex(index) {
      return this.$refs.table.indexResolver(index);
    },
    handleSelectProductType(value) {
      this.search_type_id = value;
    },
    handleCellClick(item, column) {
      if (!column.property) {
        return;
      }
      if (this.editingId === item.id) {
        return;
      }
      if (this.editingId) {
        this.util.notify(
          this,
          "w",
          this.$t("lang.title_cost"),
          "저장 또는 취소 후 다시 시도해 주시기 바랍니다."
        );
        return;
      }
      this.originPrice = JSON.parse(JSON.stringify(item.price));
      this.doRegister(item);
      this.editingId = item.id;
    },
    /** checkbox 가 v-model이 적용이 안 돼 이벤트로 처리 */
    // handleChangeRatioFlag(item, level, checked) {
    //   item.price.custom[level].ratio_flag = checked;
    // },
    handleClickSave(item) {
      this.doRegister(item);
      this.editingId = 0;
      this.visibleId = 0;
    },
    handleClickClose() {
      const itemIndex = this.items.findIndex((i) => i.id === this.editingId);
      this.items[itemIndex].price = this.originPrice;
      this.originPrice = null;
      this.editingId = 0;
      this.visibleId = 0;
    },
    handleResult(res) {
      if (res.error !== this.system.noError) {
        this.util.notify_response_error(this, this.$t("lang.title_cost"), res);
        return;
      }
    },
    handleClickHistory(item) {
      this.editingId = 0;
      this.visibleId = item.id;
    },
    handleOnChange(event) {
      this.loading = true;
      const file = event.raw;
      const reader = new FileReader();
      reader.onload = this.loadExcel;
      reader.readAsArrayBuffer(file);
    },
    loadExcel(e) {
      let tmpResult = {};
      let data = e.target.result;
      data = new Uint8Array(data);
      let excelFile;
      try {
        excelFile = XLSX.read(data, {
          type: "array",
          cellDates: true,
          cellNF: false,
          cellText: false,
        });
      } catch (ex) {
        this.util.notify_error(this, this.title, "엑셀 파일이 아닙니다.");
        return;
      }
      excelFile.SheetNames.forEach((sheetName) => {
        const costItems = XLSX.utils.sheet_to_json(
          excelFile.Sheets[sheetName],
          { header: 1 }, // 모든 헤더 정보를 array로 가져옴
          { raw: true, dateNF: "YYYY-MM-DD" }
        );
        if (costItems.length) tmpResult[sheetName] = costItems;
      });
      this.parseExcel(tmpResult[this.$t("lang.title_cost")]);
    },
    parseExcel(result) {
      const excelItems = [];
      // 헤더 정보 분리
      const excelHeaderInfo = result.splice(0, 1)[0];
      // table_product의 name에 해당하는 '품목명' 컬럼 존재 여부 확인
      // 존재하지 않으면 excel import 종료
      // 품목명이 없으면 product 정보를 찾아서 비교 할 수 없어 진행 불가
      const headerNameIndex = excelHeaderInfo.findIndex(
        (f) => f === this.excelProductInfo[1]
      );
      if (headerNameIndex < 0) {
        this.loading = false;
        this.util.notify_error(
          this,
          this.title,
          "엑셀 파일에 [" + this.$t("lang.material_name") + "] 정보가 없습니다."
        );
        return;
      }
      // table_product_price의 price에 해당하는 '기본가' 컬럼 정보의 index
      const headerPriceIndex = excelHeaderInfo.findIndex(
        (f) => f === this.excelProductInfo[2]
      );
      result.forEach((item) => {
        let data = { name: item[headerNameIndex] };
        // '기본가' 와 명칭이 일치하는 컬럼 정보가 존재하면 정보를 가져옴
        if (headerPriceIndex > -1) {
          data.price = Number.parseInt(
            this.util.removeComma(item[headerPriceIndex])
          );
        }

        // 현재 설정된 기계등급 정보를 기반으로 excel header 정보를 비교하여
        // 일치하는 컬럼의 정보만 가져옴
        this.table_customer_level.forEach((cl) => {
          const headerCustomerLevelIndex = excelHeaderInfo.findIndex(
            (f) => f === cl.code
          );
          if (headerCustomerLevelIndex > -1) {
            data[cl.id] = Number.parseInt(
              this.util.removeComma(item[headerCustomerLevelIndex])
            );
          }
        });
        // 현재 등록된 product 정보와 일치하는 '품목명' 컬럼 정보만 포함
        let product = this.table_product.find((f) => f.name === data.name);
        if (product) {
          data.product_price = JSON.parse(JSON.stringify(product.price));
          excelItems.push(data);
        }
      });
      this.doRegisterByExcel(excelItems);
    },
    parseCustomerPrice(item) {
      const newCustomers = [];
      this.table_customer_level.forEach((cl) => {
        const excelValue = item[cl.id];
        const customerLevelItem = item.product_price.customers.find(
          (f) => f.customer_level_id === cl.id
        );
        if (customerLevelItem) {
          customerLevelItem.price = excelValue;
          newCustomers.push(customerLevelItem);
        } else if (excelValue) {
          const newItem = {
            id: 0,
            customer_level_id: cl.id,
            ratio_flag: "N",
            price: excelValue,
          };
          newCustomers.push(newItem);
        }
      });
      return newCustomers;
    },
    doRegisterByExcel(excelItems) {
      const saveItems = [];
      excelItems.forEach((item) => {
        if (item.product_price.price !== item.price) {
          item.product_price.price = item.price;
        }
        item.product_price.customers = this.parseCustomerPrice(item);
        saveItems.push(item.product_price);
      });

      try {
        this.api.saveProductPriceByExcel(saveItems).then((res) => {
          this.handleResult(res);
          this.loading = false;
        });
      } catch (e) {
        this.loading = false;
      }
    },
    parseData(header) {
      const excelData = [];
      this.items.forEach((item) => {
        /**
         * 기계등급관리 메뉴에서 설정되는 정보에 따라 table_customer_level 값이 변경됨
         * excel 에 저장하기 위해서는 header 순서에 따라 적용된 값의 순서도 같아야 함
         * 그래서 적용될 값의 순서를 정렬하기 위해 index 값을 숫자로 정의함
         * table_customer_level 의 id 값에 100 을 더해 앞에
         * product code(코드), name(품목명), price(기본가) 정보가 먼저 오도록 정의함
         */
        const rowData = {
          1: item.code, // product code
          2: item.name, // product name
          3: item.price.price ? this.util.addComma(item.price.price) : 0, // product price
        };
        this.table_customer_level.forEach((cl) => {
          if (header.find((f) => f === cl.code)) {
            const price = item.price.custom[cl.id].price;
            rowData[cl.id + 100] = this.util.addComma(price);
          }
        });
        excelData.push(rowData);
      });
      return excelData;
    },
    handleClickExportExcel() {
      const workBook = XLSX.utils.book_new();
      const header = [this.makeExcelHeaderInfo()];
      const workSheet = XLSX.utils.json_to_sheet(this.parseData(header[0]), {
        origin: "A1",
      });
      XLSX.utils.sheet_add_aoa(workSheet, header);
      XLSX.utils.book_append_sheet(
        workBook,
        workSheet,
        this.$t("lang.title_cost")
      );
      XLSX.writeFile(workBook, "단가관리.xlsx");
    },
    makeExcelHeaderInfo() {
      const excelHeaderInfo = JSON.parse(JSON.stringify(this.excelProductInfo));
      this.table_customer_level.forEach((item) => {
        excelHeaderInfo.push(item.code);
      });
      return excelHeaderInfo;
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/css/_variables.scss";
.tree-container {
  width: 160px;
  overflow: auto;
  flex: 0 0 160px;
  margin-right: 10px;
  border: $border-dark;
}
.price-ratio {
  flex: 0 0 20px;
  padding: 0 3px;
}
</style>
